"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@check-light-or-dark/utils");
function filterRgbOrRgba(color) {
    var MATCH_RGB_RGBA_COLOR = utils_1.MATCH_REGEX.MATCH_RGB_RGBA_COLOR;
    var _c = color.match(MATCH_RGB_RGBA_COLOR), r = _c[1], g = _c[2], b = _c[3], a = _c[4];
    var _r = parseInt(r, 10);
    var _g = parseInt(g, 10);
    var _b = parseInt(b, 10);
    if (a) {
        var _a = parseFloat(a);
        return utils_1.rgbaToRgb(_r, _g, _b, _a);
    }
    return {
        r: _r,
        g: _g,
        b: _b
    };
}
function lightOrdarkColor(color) {
    var hexRegex = utils_1.VALIDATE_REGEX.VALIDATE_HEX_COLOR, rgbRegex = utils_1.VALIDATE_REGEX.VALIDATE_RGB_RGBA_COLOR;
    if (hexRegex.test(color)) {
        var brightness = utils_1.getBrightness(utils_1.hexToRgb(color));
        return brightness > utils_1.BRIGHTNESS_DEGREE
            ? 'light'
            : 'dark';
    }
    else if (rgbRegex.test(color)) {
        var brightness = utils_1.getBrightness(filterRgbOrRgba(color));
        return brightness > utils_1.BRIGHTNESS_DEGREE
            ? 'light'
            : 'dark';
    }
    return null;
}
exports.default = lightOrdarkColor;
